import { Component, ErrorHandler, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import swal from 'sweetalert2';
import { UserService } from '../../../shared/user.service';

declare const $: any;



@Component({
  selector: 'app-lead-form',
  templateUrl: './lead-form.component.html',
  styleUrls: ['./lead-form.component.css','./lead-form.component.scss']
})
export class LeadFormComponent implements OnInit {
  title="Create Lead";
  data: any = {};
  c: any = {};
  d: any = {};
  s: any = {};
  n: any = {};
  Statelist: any = {};
  CATEGORYlist: any = {};
  Districtlist: any = {};
  category: any = [];
  categorydata: any;
  subcategory: any;
  subcategorydata: any;
  sub_category_id: any;
  category_ids: any;
  Cat_Name: any;
  DOC_NOs: any;
  DOC_NO : any;
  mode: any;
  Industrieslist : any={};
  Ratinglist : any={};
  Leadsourcelist : any={};
  Leadstatuslist : any={};
  LeadCategorylist: any={};
  hide: boolean;
  fileToUpload: File;
  photoImageUrl: any;
  formInvalid: boolean = false;
  Image_path: string;
  constructor(private  UserService:UserService, private router: Router, private route: ActivatedRoute, private errorHandler: ErrorHandler,
    ) {  }
  storedTheme: string;
  ngOnInit() {

    this.route.params.subscribe(params => {
      
      this.DOC_NOs = params['DOC_NOs'];
      this.mode = params['mode'];

      if (this.DOC_NOs > 0) {
        this.GetByIdLead(this.DOC_NOs)
      }
      if (this.mode == 'View') {
        this.hide = true;

      }
     else if (this.mode == 'Edit') {
      this.hide = true;
    }
    });
    this.c.COUNTRY='INDIA'

    if(this.mode=='View'){
      this.title = "View Lead ";
    }
    else if(this.mode=='Edit'){
      this.title = "Edit Lead ";
    } 
    this.GetAllData();
    this.c.COUNTRY='INDIA'
    this.storedTheme = localStorage.getItem('theme-color');
    this.getcategory();
  }

  GetAllData() {
    debugger;

    this.data = this.UserService.GetAllDistricts();
    this.data.subscribe(
      (response: any) => {
        this.Districtlist = response.Result;
        console.log("district");
        console.log(this.Districtlist)
      })

    this.data = this.UserService.GetAllStatelist();
    this.data.subscribe(
      (response: any) => {
        this.Statelist = response.Result;
        console.log("state");
        console.log(this.Statelist)
      })



      this.data = this.UserService.GetAllCategorylist();
    this.data.subscribe(
      (response: any) => {
        this.CATEGORYlist = response.Result;
        console.log("category");
        console.log(this.CATEGORYlist)
      })


      this.data = this.UserService.GetAllIndustries();
      this.data.subscribe(
        (response: any) => {
          this.Industrieslist = response.Result;
        console.log("Industrieslist");
         console.log(this.Industrieslist)
        })


        this.data = this.UserService.GetAllRatings();
        this.data.subscribe(
          (response: any) => {
            this.Ratinglist = response.Result;
          console.log("Ratinglist");
           console.log(this.Ratinglist)
          })



        this.data = this.UserService.GetAllLeadSource();
          this.data.subscribe(
            (response: any) => {
              this.Leadsourcelist = response.Result;
            console.log("Leadsourcelist");
             console.log(this.Leadsourcelist)
            })



          this.data = this.UserService.GetAllLeadStatus();
          this.data.subscribe(
              (response: any) => {
                this.Leadstatuslist = response.Result;
              console.log("Leadstatuslist");
               console.log(this.Leadstatuslist)
              })

              this.data = this.UserService.GetAllLeadCategory();
            this.data.subscribe(
              (response: any) => {
                this.LeadCategorylist = response.Result;
              console.log("LeadCategorylist");
               console.log(this.LeadCategorylist)
              })
      
      


    }
    getByid(PRODUCT_CATEGORY) {  
      alert(PRODUCT_CATEGORY)
     debugger;
      for(let i=0;i<this.category.length;i++)
      {
        if(this.category[i].cat_id==PRODUCT_CATEGORY)
          {
            debugger;
            this.Cat_Name=this.category[i].Cat_Name;
           
            this.Cat_Name=this.Cat_Name
            
           
          }
      }
  
      debugger;
      this.subcategorydata = this.UserService.GetByIdsubcat(this.Cat_Name);
      this.subcategorydata.subscribe(
        (Resp: any) => {
          debugger;
          this.subcategory=[];
          this.subcategory = Resp.Result;
        }
      )
    }
    
  
    getcategory() {
      this.categorydata = this.UserService.loadallcategorydetails();
      this.categorydata.subscribe(
        (Resp: any) => {
          console.log(Resp)
          this.category = Resp.Result;
        }
      )
    }
    category_id:any;
    
    getcategorycode(Cat_Name)
    {
      debugger;
      console.log(this.category_id);
      console.log(this.category);
       for(let i=0;i<this.category.length;i++)
       {
         if(this.category[i].Cat_Name==Cat_Name)
           {
             debugger;
             this.category_id=this.category[i].cat_id;
             return this.category_id;
           //  alert(this.category_id);
            
           }
       }
    }
  
    getsubcategory(subCat_Name)
    {
      console.log("mainsubcategory");
      console.log(this.subcategory);
      for(let i=0;i<this.subcategory.length;i++)
      {
        debugger;
        if(this.subcategory[i].subCat_Name==subCat_Name)
          {
            debugger;
            this.sub_category_id=this.subcategory[i].subcat_id;
            return this.sub_category_id;
  
          }
      }
  
    }

    SaveLead(Lead: NgForm) {

      if (Lead.invalid) {
        this.formInvalid = true;
        swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
        return;
      }
    
      else {
       // Employee.value.Aadhar_Upload_Path = this.getFeasibilityFUrlAdhara();
        //Employee.value.Pan_Upload_Path = this.getFeasibilityUrlPan();
    
       // Vendor.value.Company_Logo_Path = this.getFeasibilityFUrlAdhara();
       Lead.value.PRODUCT_CATEGORY= this.c.PRODUCT_CATEGORY
       Lead.value.PRODUCT_SUB_CATEGORY=this.c.PRODUCT_SUB_CATEGORY;
        this.data = this.UserService.PostLead(Lead.value);
        this.data.subscribe(
          (response) => {
            Lead.reset();
            Lead.resetForm();
            Lead.form.markAsPristine();
            Lead.form.markAsUntouched();
            swal('Success!', 'Lead  Details Added Successfully .', 'success');
            this.router.navigate(['/home/lead']);
            document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
            if (error.status == 401 || error.status == 500) {
              this.errorHandler.handleError(error);
            }
            else if (error.status == 400) {
              swal('Warning!', error.error.Message, 'warning');
            }
          });
    
        } 
      }
      GetByIdLead(DOC_NOs){
        debugger;
        // this.DOC_NOs=DOC_NO;      
         document.getElementById('loader-spinner').style.display = "block";
             this.data = this.UserService.GetByIdLead(DOC_NOs);
             this.data.subscribe(
               (response: any) => {
                 this.c = response; 
                 this.photoImageUrl = this.c.LEAD_IMAGE_UPLOAD_PATH;   
                 console.log(this.c)    
                     
                 document.getElementById('loader-spinner').style.display = "none";
               },(error) => {
                 document.getElementById('loader-spinner').style.display = "none";
                 if (error.status == 401 || error.status == 500) {
                   this.errorHandler.handleError(error);
                 }
                 else if (error.status == 400) {
                   swal('Warning!', error.error.Message, 'warning');
                 }
               });
     
               
       }
 
 
    FileInputPhoto(file: FileList) {
      debugger
        
      //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
      let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|JPEG|JPG)$/;
      let s: any = file.item(0).size / 1024;
      let size: any = parseFloat(s).toFixed(2);
      let uploadedFilename = file.item(0).name;
      if (uploadedFilename.match(regex) && (size <= 5048)) {             
        this.fileToUpload = file.item(0);
        var reader = new FileReader();
        reader.onload = (event: any) => {
           this.photoImageUrl = event.target.result;
        }
        reader.readAsDataURL(this.fileToUpload);
        const data = new FormData();
        data.append("UploadedImage", file.item(0));
        let x = this.UserService.uploadImagesFilePhoto(data);
        //this.data = this.UserService.PostEmployee(Employee.value);
        x.subscribe(
          (response) => {
            
    
          }, (error) => {
            let i: any = document.getElementById('Image_path');
            i.value = "";
            if (error.status == 400) {
               this.Image_path = "assets/images/image-default.png";
              swal('Warning!', error.error.Message, 'warning');
            }
          });
      }
      else {
        let i: any = document.getElementById('Image_path');
        i.value = "";
        if (!uploadedFilename.match(regex))
          swal('Warning!', "Please upload and .jpeg,jpg or png", 'warning');
        else if (size > 2048)
          swal('Warning!', "Please upload image file less than 2mb", 'warning');
      }
    }
    
    
    getImageProofPDFUrl() {
      let imagename = null;
      try {
        imagename = document.getElementById('Image_path');
        return imagename.files[0].name;
      }
      catch (e) {
        return null;
      }
    }

    UpdateLead(Lead: NgForm) {

      //Associate.value.AdressModel = this.AdressDetails;
    //  Associate.value.BankModel = this.bankDetails;
      this.data = this.UserService.UpdateLead(Lead.value, this.DOC_NOs);
      this.data.subscribe(
        (response) => {
         // data.reset();
          //data.resetForm();
         // data.form.markAsPristine();
         // data.form.markAsUntouched();
  
          swal('Success!', 'Lead details updated Successfully .', 'success');
          document.getElementById('loader-spinner').style.display = "none";
          this.router.navigate(['/home/lead']);
        }, (error) => {
          document.getElementById('loader-spinner').style.display = "none";
          if (error.status == 401 || error.status == 500) {
            this.errorHandler.handleError(error);
          }
          else if (error.status == 400) {
            swal('Warning!', error.error.Message, 'warning');
          }
        });
    }
  
    
  setTheme(theme) {
    localStorage.setItem('theme-color', theme);
    this.storedTheme = localStorage.getItem('theme-color');
  }
}



// WEBPACK FOOTER //
// ./src/app/Pages/Lead/lead-form/lead-form.component.ts